<template>
  <div tabindex="-1" role="dialog" aria-modal="true" aria-label="提示" class="el-message-box__wrapper" style="z-index: 2070;">
    <div class="el-message-box">
      <div class="el-message-box__header">
        <div class="el-message-box__title">
          <!---->
          <i class="el-icon-warning"></i><span>{{ title }}</span>
        </div>
        <!-- <button type="button" aria-label="Close" class="el-message-box__headerbtn"><i class="el-message-box__close el-icon-close"></i></button> -->
      </div>
      <div class="el-message-box__content">
        <div class="el-message-box__container">
          <div class="el-message-box__message">
            <p>{{ msg }}</p>
            <p class="note" v-if="msgNote">还剩余<span>{{ msgNote }}次校验机会</span>，用光次数后流程会自动关闭，请慎重</p>
          </div>
        </div>
      </div>
      <div class="el-message-box__btns">
        <!-- <button type="button" class="el-button el-button--default el-button--small"><span>取消</span></button> -->
        <button type="button" class="el-button el-button--default el-button--small el-button--primary " @click="getClose"><span>知道了</span></button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: ['title', 'msg', 'msgNote'],
  methods: {
    getClose() {
      this.$emit('getDialogClose')
    }
  }
}
</script>
<style lang="scss" scoped>
.el-message-box__wrapper {
  .el-message-box {
    padding: 24px 24px 6px;
    width: 460px;
    .el-message-box__title {
      border-bottom: 0 none !important;
      line-height: 21px;
      span {
        font-weight: bold;
        font-size: 16px;
        color: #303b50;
        line-height: 21px;
      }
    }
  }
  .el-message-box__message {
    padding-left: 20px;
    p {
      font-size: 14px;
      color: #333;
      line-height: 19px;
      letter-spacing: 1px;
      margin-bottom: 12px;
    }
    .note {
      color: #929292;
      line-height: 16px;
      letter-spacing: 1px;
      font-size: 12px;
      span {
        color: #e02020;
      }
    }
  }
  .el-icon-warning {
    font-size: 16px;
    color: #e89e1c;
    margin-right: 8px;
  }
}
</style>